import styled from "styled-components";

export default styled.a`
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  padding: 1.125em 2.9375rem;
  cursor: pointer;
  text-transform: uppercase;
  color: #ffffff;
  font-family: "CircularStd-Book", sans-serif;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
  }
  &:before {
    top: 0;
    left: 0;
    background-color: #f76267;
    z-index: -1;
    transition: background-color 0.2s;
  }
  &:after {
    content: "";
    top: 10px;
    left: 10px;
    background-color: #ebe8e1;
    z-index: -2;
  }
  &:hover:before {
    background-color: #e8595e;
  }
  @media (max-width: 680px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Button/index.js